/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_JacketInputs */

const en_val_jacket = /** @type {(inputs: Val_JacketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jacket`)
};

const es_val_jacket = /** @type {(inputs: Val_JacketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaqueta`)
};

const fr_val_jacket = /** @type {(inputs: Val_JacketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veste`)
};

const de_val_jacket = /** @type {(inputs: Val_JacketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jacke`)
};

const ja_val_jacket = /** @type {(inputs: Val_JacketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ジャケット`)
};

const zh_val_jacket = /** @type {(inputs: Val_JacketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`夹克`)
};

const ar_val_jacket = /** @type {(inputs: Val_JacketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جاكيت`)
};

const id_val_jacket = /** @type {(inputs: Val_JacketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jaket`)
};

const it_val_jacket = /** @type {(inputs: Val_JacketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giacca`)
};

const ru_val_jacket = /** @type {(inputs: Val_JacketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Куртка`)
};

const pt_val_jacket = /** @type {(inputs: Val_JacketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jaqueta`)
};

const ko_val_jacket = /** @type {(inputs: Val_JacketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`재킷`)
};

/**
* | output |
* | --- |
* | "Jacket" |
*
* @param {Val_JacketInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_jacket = /** @type {((inputs?: Val_JacketInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_JacketInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_jacket(inputs)
	if (locale === "es") return es_val_jacket(inputs)
	if (locale === "fr") return fr_val_jacket(inputs)
	if (locale === "de") return de_val_jacket(inputs)
	if (locale === "ja") return ja_val_jacket(inputs)
	if (locale === "zh") return zh_val_jacket(inputs)
	if (locale === "ar") return ar_val_jacket(inputs)
	if (locale === "id") return id_val_jacket(inputs)
	if (locale === "it") return it_val_jacket(inputs)
	if (locale === "ru") return ru_val_jacket(inputs)
	if (locale === "pt") return pt_val_jacket(inputs)
	return ko_val_jacket(inputs)
});